import React, { useRef } from 'react';
import { CustomProvider, DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import ptBR from 'rsuite/locales/pt_BR';
import { I18n } from 'react-redux-i18n';
import {
  endOfDay, startOfDay, startOfMonth, subDays,
} from 'date-fns';
import '../../scss/plugins/_rsuite-daterangepicker.scss';

const defaultRangeValue = [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())];

export default function ({ onChange, defaultValue, ...props }) {
  const pendingValue = useRef(defaultValue || defaultRangeValue);

  const commit = (value, event) => {
    pendingValue.current = value;
    if (onChange) {
      onChange(value, event);
    }
  };

  return (
    <CustomProvider locale={ptBR}>
      {/* captura o Enter que sobe do input do rsuite; a div em si nao e interativa */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        onKeyDown={(event) => {
          if (event.key === 'Enter' && pendingValue.current) {
            commit(pendingValue.current, event);
          }
        }}
      >
        <DateRangePicker
          id="dateRangePicker"
          placeholder={I18n.t('BEE2440' /* Nenhuma data selecionada */)}
          format="dd/MM/yyyy"
          character=" - "
          defaultValue={defaultValue || defaultRangeValue}
          appearance="subtle"
          className="bg-dark text-white"
          cleanable={false}
          ranges={[
            {
              label: I18n.t('BEE2441' /* Este mês */),
              value: [startOfMonth(new Date()), endOfDay(new Date())],
            },
            {
              label: I18n.t('BEE2442', { 0: 30 } /* Últimos %{0} dias */),
              value: [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())],
            },
            {
              label: I18n.t('BEE2442', { 0: 90 } /* Últimos %{0} dias */),
              value: [startOfDay(subDays(new Date(), 90)), endOfDay(new Date())],
            },
          ]}
          {...props}
          onChange={(value) => { pendingValue.current = value; }}
          onOk={(value, event) => commit(value, event)}
          onShortcutClick={(range, event) => commit(range.value, event)}
        />
      </div>
    </CustomProvider>
  );
}
